/*
 * Copyright (C) 2018 Bruno López Trigo
 * 
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; either version 2
 * of the License, or (at your option) any later version.

 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.

 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 */

import React, { Component } from "react";
import Routes from "./components/global/Routes";
import { withRouter } from "react-router-dom";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import { LABELS } from "./language";
import { startSession, closeSession } from "./components/global/API";


const theme = createMuiTheme({
  typography: {
    useNextVariants: true
  },
  palette: {
    primary:{500: "#4caf50"},
    secondary:{A400:"#4caf50"},
  },
});

class App extends Component {
  constructor() {
    console.log(localStorage.getItem("mode"))
    console.log(localStorage.getItem("token"))
    super();
    this.state = {
      language: {
        id: "en",
        labels: LABELS
      },
      classifierExists: false,
      algorithm: "J48",
      token: localStorage.getItem("token"),
      mode: localStorage.getItem("mode"),
      reset: false,
      algorithmChecked:undefined,
    };
    this.handleLanguage = this.handleLanguage.bind(this);
    this.goToClassifiers = this.goToClassifiers.bind(this);
    this.goToDatasets = this.goToDatasets.bind(this);
    this.handleSession = this.handleSession.bind(this);
    this.handleSessionBeginner = this.handleSessionBeginner.bind(this);
    this.handleCloseSession = this.handleCloseSession.bind(this);
    this.classifierDontExist = this.classifierDontExist.bind(this);
    this.handleAlgorithmChange = this.handleAlgorithmChange.bind(this);
    this.changeCheckAlgorithm = this.changeCheckAlgorithm.bind(this);
    this.changeAlgorithmDataset = this.changeAlgorithmDataset.bind(this);
    this.goToBuilder = this.goToBuilder.bind(this);
    this.changeValues = this.changeValues.bind(this);
    this.goToClassifiersNewNameBegginer = this.goToClassifiersNewNameBegginer.bind(this);
    this.goToClassifiersNewNameScratch = this.goToClassifiersNewNameScratch.bind(this);
    this.goToComparation = this.goToComparation.bind(this);
    this.goToDisplay = this.goToDisplay.bind(this);
    this.goToAbout = this.goToAbout.bind(this);
    this.goToHelp = this.goToHelp.bind(this);
  }

  classifierDontExist(algorithm) {
    this.setState({
      classifierExists: true,
      algorithm
    });
  }

  async handleSession() {
    const response = await startSession();
    if (response.error) {
      this.setState({
        error: true,
        message: response.data
      });
    } else {
      localStorage.setItem("token", response.data);
      localStorage.setItem("mode", "expert");
      this.setState({
        token: response.data,
        mode:"expert"
      });
    }
  }
  async handleSessionBeginner() {
    const response = await startSession();
    if (response.error) {
      this.setState({
        error: true,
        message: response.data
      });
    } else {
      localStorage.setItem("token", response.data);
      localStorage.setItem("mode", "beginner");
      this.setState({
        token: response.data,
        mode:"beginner"
      });
    }
  }

  async handleAlgorithmChange(algorithm) {
    console.log(algorithm)
    var lastAlgorithm= this.state.algorithm
      this.setState({
        lastAlgorithm:lastAlgorithm,
        algorithm:algorithm,
    })

  }
  changeCheckAlgorithm(algorithm) {
    this.setState({
      algorithmChecked :algorithm
    });
  }

  async changeAlgorithmDataset(algorithm,dataset) {
    console.log(algorithm)
    var lastAlgorithm= this.state.algorithm
    this.setState({
      lastAlgorithm:lastAlgorithm,
      algorithm:algorithm,
    })

  }

  componentDidUpdate() {
    if (
      this.props.location.pathname === "/datasets" &&
      this.state.classifierExists
    ) {
      console.log(this.state.algorithm);
      this.setState({
        classifierExists: false
      });
    }
  }

  async handleCloseSession() {
    await closeSession(this.state.token);
    localStorage.clear();
    this.setState({ token: undefined });
  }

  handleLanguage(id) {
    this.setState(prevState => ({
      language: {
        ...prevState.language,
        id
      }
    }));
  }

  goToClassifiers(dataset) {
    console.log(dataset)
    this.setState({
      dataset:dataset,
    });
    if(this.state.mode ==="expert") {
      this.props.history.push("classifiers");
    }else if(this.state.mode === "beginner"){
      this.props.history.push("classifiersAll");
    }
  }
  goToClassifiersNewNameBegginer(dataset,file) {
    console.log(dataset)
    this.setState({
      datasetNewBeginner:dataset,
      dataset:"new",
      file:file,
    });
    if(this.state.mode ==="expert") {
      this.props.history.push("classifiers");
    }else if(this.state.mode === "beginner"){
      this.props.history.push("classifiersAll");
    }
  }
  goToClassifiersNewNameScratch(dataset,file) {
    console.log(dataset)
    console.log(file)
    this.setState({
      datasetNewBeginner:dataset,
      dataset:"newScratch",
      file:file,
    });
    if(this.state.mode ==="expert") {
      this.props.history.push("classifiers");
    }else if(this.state.mode === "beginner"){
      this.props.history.push("classifiersAll");
    }
  }
  goToBuilder() {
    this.props.history.push("builder");
  }
  goToAbout() {
    this.props.history.push("about");
  }
  goToHelp() {
    this.props.history.push("help");
  }
  goToComparation() {
    this.props.history.push("algorithmsComparationGraph");
  }
  goToDisplay() {
    this.props.history.push("classifiers");
  }
  goToDatasets() {
    console.log('Aqui chega a cambiar o datatset')
    this.setState({
      dataset:undefined
    });
  }
  changeValues(values){
    this.setState({
      values:values,
    })
  }

  render() {
    return (
      <MuiThemeProvider theme={theme}>
        <Routes
          reset={this.state.reset}
          token={this.state.token}
          startSession={this.handleSession}
          startSessionBeginner={this.handleSessionBeginner}
          mode={this.state.mode}
          closeSession={this.handleCloseSession}
          language={this.state.language}
          handleLanguageChange={this.handleLanguage}
          handleDataset={this.goToClassifiers}
          handleDatasetNewNameBeginner={this.goToClassifiersNewNameBegginer}
          handleDatasetNewNameScratch={this.goToClassifiersNewNameScratch}
          goToDatasets={this.goToDatasets}
          changeAlgorithm={this.handleAlgorithmChange}
          changeCheckAlgorithm = {this.changeCheckAlgorithm}
          changeAlgorithmDataset = {this.changeAlgorithmDataset}
          dataset={this.state.dataset}
          datasetNewBeginner={this.state.datasetNewBeginner}
          file={this.state.file}
          classifierDontExist={this.classifierDontExist}
          classifierExists={this.state.classifierExists}
          algorithm={this.state.algorithm}
          lastAlgorithm={this.state.lastAlgorithm}
          algorithmChecked = {this.state.algorithmChecked}
          goToBuilder ={this.goToBuilder}
          changeValues = {this.changeValues}
          values={this.state.values}
          goToComparation={this.goToComparation}
          goToDisplay={this.goToDisplay}
          goToAbout={this.goToAbout}
          goToHelp={this.goToHelp}
        />
      </MuiThemeProvider>
    );
  }
}

export default withRouter(App);
